import React, { useState } from 'react'
import scrollTo from 'gatsby-plugin-smoothscroll'
import { StaticImage } from 'gatsby-plugin-image'
import { useIntl } from 'react-intl'
import { useTheme } from 'styled-components'

import SEO from '../components/SEO'
import Header from '../components/Header'
import Footer from '../components/Footer'
import ScrollToLearnMore from '../components/ScrollToLearnMore'
import VoiceControl from '../components/VoiceControl'
import Geofencing from '../components/Geofencing'
import BookDemo from '../components/BookDemo'
import VoiceControlCarousel from '../components/VoiceControlCarousel'
import AutomationOptions from '../components/AutomationOptions'
import IconsScroll from '../components/IconsScroll'
import TextPlusImage from '../components/TextPlusImage'
import IntegratorTestimonial from '../components/IntegratorTestimonial'
import AccessPartnerPricing from '../components/AccessPartnerPricing'
import ProductPricing from '../components/ProductPricing'
import CoverMobile from '../components/icons/cover-mobile'
import CoverVoice from '../components/icons/cover-voice'
import CoverAutomation from '../components/icons/cover-automation'
import CoverGeofencing from '../components/icons/cover-geofencing'
import WorksWithLogosLoxone from '../components/icons/works-with-logos-loxone'

import { ProductSections } from '../constants/data/products'
import { AutomationOption, CallName } from '../constants/data/common'

import { TitleL, TitleM, TitleXS, BodyM, BodyS } from '../styles/Typography'
import { Container, Section } from '../styles/PageLayout'
import { ButtonOutline } from '../styles/components/ButtonStyled'
import { AutomationsVideoStyled } from '../styles/components/AutomationsVideoStyled'
import ProductsProfessionalsLoxoneStyled from '../styles/pages/ProductsProfessionalsLoxoneStyled'

const ProductsProfessionalsLoxone = () => {
  const intl = useIntl()
  const theme = useTheme()

  const [automationsGroup, setAutomationsGroup] = useState(2)

  return (
    <>
      <SEO
        title={intl.formatMessage({ id: 'page_products_professionals_loxone_seo_title' })}
        description={intl.formatMessage({ id: 'page_products_professionals_loxone_seo_description' })}
        pathname="/products-professionals-loxone"
      />
      <Header />
      <ProductsProfessionalsLoxoneStyled>
        <Section $isCoverSection className="section-one">
          <Container $mobileColumn $alignItems="flex-end" $mobileAlignItems="center" $gap="2rem">
            <div className="content">
              <TitleL className="title">{intl.formatMessage({ id: 'page_products_professionals_loxone_title_1' })}</TitleL>
              <div className="img hide-lg">
                <StaticImage
                  src="https://www.1home.io/xassets/products-professionals-loxone-hero.webp"
                  alt={intl.formatMessage({ id: 'page_products_professionals_loxone_alt_1' })}
                  placeholder="none"
                  quality="100"
                  loading="eager"
                />
              </div>
              <div className="list">
                <div className="list-item">
                  <CoverVoice className="item-icon" />
                  <BodyM className="text">
                    {intl.formatMessage({ id: 'page_products_professionals_loxone_text_1_1' }, { b: (msg) => <b>{msg}</b> })}
                  </BodyM>
                </div>
                <div className="list-item">
                  <CoverGeofencing className="item-icon" />
                  <BodyM className="text">
                    {intl.formatMessage({ id: 'page_products_professionals_loxone_text_1_2' }, { b: (msg) => <b>{msg}</b> })}
                  </BodyM>
                </div>
                <div className="list-item">
                  <CoverAutomation className="item-icon" />
                  <BodyM className="text">
                    {intl.formatMessage({ id: 'page_products_professionals_loxone_text_1_3' }, { b: (msg) => <b>{msg}</b> })}
                  </BodyM>
                </div>
                <div className="list-item">
                  <CoverMobile className="item-icon" />
                  <BodyM className="text">
                    {intl.formatMessage({ id: 'page_products_professionals_loxone_text_1_4' }, { b: (msg) => <b>{msg}</b> })}
                  </BodyM>
                </div>
              </div>
            </div>
            <div className="img hide-md">
              <StaticImage
                src="https://www.1home.io/xassets/products-professionals-loxone-hero.webp"
                alt={intl.formatMessage({ id: 'page_products_professionals_loxone_alt_1' })}
                placeholder="none"
                quality="100"
                loading="eager"
              />
              <div className="scroll" onClick={() => scrollTo('#section-two')}>
                <ScrollToLearnMore />
                <BodyS $weight={700}>{intl.formatMessage({ id: 'scroll_to_learn_more' })}</BodyS>
              </div>
            </div>
          </Container>
        </Section>

        <Section $alignCenter $bgColor={theme.backgroundLight} className="section-two">
          <Container $column $mobileColumn $alignItems="center">
            <TitleXS className="title">{intl.formatMessage({ id: 'page_products_professionals_loxone_title_2' })}</TitleXS>
            <WorksWithLogosLoxone />
          </Container>
        </Section>

        <AccessPartnerPricing />

        <VoiceControl callName={CallName.HeyGoogle} />

        <Geofencing />

        <VoiceControlCarousel title={intl.formatMessage({ id: 'page_products_professionals_loxone_title_3' })} />

        <BookDemo />

        <AutomationsVideoStyled $alignCenter>
          <Container $column $mobileColumn $alignItems="center">
            <TitleM className="title">{intl.formatMessage({ id: 'page_products_professionals_loxone_title_4' })}</TitleM>
            <div className="btn-group">
              <ButtonOutline
                className={automationsGroup === 1 && 'is-selected'}
                onClick={() => {
                  setAutomationsGroup(1)
                }}
              >
                {intl.formatMessage({ id: 'google_home' })}
              </ButtonOutline>
              <ButtonOutline
                className={automationsGroup === 2 && 'is-selected'}
                onClick={() => {
                  setAutomationsGroup(2)
                }}
              >
                {intl.formatMessage({ id: 'amazon_alexa' })}
              </ButtonOutline>
            </div>
            {automationsGroup === 1 && (
              <div className="automations-group">
                <div className="automations">
                  <div className="video">
                    <video width="100%" autoPlay={true} loop={true} muted={true} playsInline>
                      <source src="https://www.1home.io/xassets/loxone-voice-control-video-1.mp4" type="video/mp4" />
                    </video>
                  </div>
                  <div className="circle" />
                  <BodyM className="text">{intl.formatMessage({ id: 'page_products_professionals_loxone_text_2_1' })}</BodyM>
                </div>
                <div className="automations">
                  <div className="video">
                    <video width="100%" autoPlay={true} loop={true} muted={true} playsInline>
                      <source src="https://www.1home.io/xassets/loxone-voice-control-video-1.mp4" type="video/mp4" />
                    </video>
                  </div>
                  <div className="circle" />
                  <BodyM className="text">{intl.formatMessage({ id: 'page_products_professionals_loxone_text_2_2' })}</BodyM>
                </div>
              </div>
            )}
            {automationsGroup === 2 && (
              <div className="automations-group">
                <div className="automations">
                  <div className="video">
                    <video width="100%" autoPlay={true} loop={true} muted={true} playsInline>
                      <source src="https://www.1home.io/xassets/loxone-voice-control-video-3.mp4" type="video/mp4" />
                    </video>
                  </div>
                  <div className="circle" />
                  <BodyM className="text">{intl.formatMessage({ id: 'page_products_professionals_loxone_text_2_3' })}</BodyM>
                </div>
                <div className="automations">
                  <div className="video">
                    <video width="100%" autoPlay={true} loop={true} muted={true} playsInline>
                      <source src="https://www.1home.io/xassets/loxone-voice-control-video-4.mp4" type="video/mp4" />
                    </video>
                  </div>
                  <div className="circle" />
                  <BodyM className="text">{intl.formatMessage({ id: 'page_products_professionals_loxone_text_2_4' })}</BodyM>
                </div>
              </div>
            )}
          </Container>
        </AutomationsVideoStyled>

        <AutomationOptions
          title={intl.formatMessage({ id: 'page_products_professionals_loxone_title_5' })}
          options={[AutomationOption.GoogleHome, AutomationOption.AmazonAlexa]}
          activeOption={AutomationOption.GoogleHome}
        />

        <AutomationsVideoStyled $alignCenter>
          <Container $column $mobileColumn $alignItems="center">
            <TitleM className="title">{intl.formatMessage({ id: 'page_products_professionals_loxone_title_6' })}</TitleM>
            <div className="btn-group">
              <ButtonOutline
                className={automationsGroup === 1 && 'is-selected'}
                onClick={() => {
                  setAutomationsGroup(1)
                }}
              >
                {intl.formatMessage({ id: 'google_home' })}
              </ButtonOutline>
              <ButtonOutline
                className={automationsGroup === 2 && 'is-selected'}
                onClick={() => {
                  setAutomationsGroup(2)
                }}
              >
                {intl.formatMessage({ id: 'amazon_alexa' })}
              </ButtonOutline>
            </div>
            {automationsGroup === 1 && (
              <div className="automations-group">
                <div className="automations">
                  <div className="video">
                    <video width="100%" autoPlay={true} loop={true} muted={true} playsInline>
                      <source src="https://www.1home.io/xassets/products-professionals-loxone-video-1.mp4" type="video/mp4" />
                    </video>
                  </div>
                  <div className="circle" />
                  <BodyM className="text">{intl.formatMessage({ id: 'page_products_professionals_loxone_text_3_1' })}</BodyM>
                </div>
                <div className="automations">
                  <div className="video">
                    <video width="100%" autoPlay={true} loop={true} muted={true} playsInline>
                      <source src="https://www.1home.io/xassets/products-professionals-loxone-video-2.mp4" type="video/mp4" />
                    </video>
                  </div>
                  <div className="circle" />
                  <BodyM className="text">{intl.formatMessage({ id: 'page_products_professionals_loxone_text_3_2' })}</BodyM>
                </div>
              </div>
            )}
            {automationsGroup === 2 && (
              <div className="automations-group">
                <div className="automations">
                  <div className="video">
                    <video width="100%" autoPlay={true} loop={true} muted={true} playsInline>
                      <source src="https://www.1home.io/xassets/products-professionals-loxone-video-3.mp4" type="video/mp4" />
                    </video>
                  </div>
                  <div className="circle" />
                  <BodyM className="text">{intl.formatMessage({ id: 'page_products_professionals_loxone_text_3_3' })}</BodyM>
                </div>
                <div className="automations">
                  <div className="video">
                    <video width="100%" autoPlay={true} loop={true} muted={true} playsInline>
                      <source src="https://www.1home.io/xassets/products-professionals-loxone-video-4.mp4" type="video/mp4" />
                    </video>
                  </div>
                  <div className="circle" />
                  <BodyM className="text">{intl.formatMessage({ id: 'page_products_professionals_loxone_text_3_4' })}</BodyM>
                </div>
              </div>
            )}
          </Container>
        </AutomationsVideoStyled>

        <Section $alignCenter className="section-three">
          <Container $column $mobileColumn $alignItems="center" $padding="0 1rem">
            <TitleM className="title">{intl.formatMessage({ id: 'page_products_professionals_loxone_title_7' })}</TitleM>
          </Container>
          <IconsScroll imgAlt={intl.formatMessage({ id: 'page_products_professionals_loxone_alt_2' })} />
        </Section>

        <Section className="section-four">
          <Container $column $mobileColumn $alignItems="center">
            <TitleM className="title">{intl.formatMessage({ id: 'page_products_professionals_loxone_title_8' })}</TitleM>
            <TextPlusImage
              title={intl.formatMessage({ id: 'page_products_professionals_loxone_text_4_1' })}
              text={intl.formatMessage({ id: 'page_products_professionals_loxone_text_4_2' })}
              hasVideo
              videoLink="https://www.youtube.com/embed/IH4cQN3yH7s"
            />
            <TextPlusImage
              title={intl.formatMessage({ id: 'page_products_professionals_loxone_text_5_1' })}
              text={intl.formatMessage({ id: 'page_products_professionals_loxone_text_5_2' })}
              imgComponent={
                <StaticImage
                  src="https://www.1home.io/xassets/how-it-works-group-why-choose-3.webp"
                  alt={intl.formatMessage({ id: 'page_products_professionals_loxone_alt_3' })}
                  placeholder="none"
                  quality="100"
                />
              }
            />
            <TextPlusImage
              title={intl.formatMessage({ id: 'page_products_professionals_loxone_text_6_1' })}
              text={intl.formatMessage({ id: 'page_products_professionals_loxone_text_6_2' })}
              imgComponent={
                <StaticImage
                  src="https://www.1home.io/xassets/how-it-works-group-why-choose-4.webp"
                  alt={intl.formatMessage({ id: 'page_products_professionals_loxone_alt_3' })}
                  placeholder="none"
                  quality="100"
                />
              }
            />
          </Container>
        </Section>

        <BookDemo />

        <IntegratorTestimonial isBtb />

        <AccessPartnerPricing />

        <ProductPricing productsToShow={[ProductSections.Bridge]} />

        <BookDemo />
      </ProductsProfessionalsLoxoneStyled>
      <Footer />
    </>
  )
}

export default ProductsProfessionalsLoxone
